// API Configuration

// Fallback API endpoint
const FALLBACK_API_ENDPOINT =
  process.env.REACT_APP_API_URL || "https://student.aitthisone.com/api";

// Function to clear cached endpoint
export const clearCachedEndpoint = () => {
  sessionStorage.removeItem("apiEndpoint");
  if (process.env.NODE_ENV === "development") {
    console.log("🗑️ Cached API endpoint cleared");
  }
};

// Function to force refresh endpoint
export const refreshApiEndpoint = async () => {
  clearCachedEndpoint();
  return getApiUrl();
};

// Get the current API URL - simplified and production-ready
export const getApiUrl = (): string => {
  // In production, use environment variable or fallback directly
  const envUrl = process.env.REACT_APP_API_URL;

  // Use environment variable if available
  if (envUrl && envUrl !== "undefined" && envUrl !== "null") {
    return envUrl;
  }

  return FALLBACK_API_ENDPOINT;
};

// Dynamic API URL - will be resolved at runtime
export const getAPI_URL = () => getApiUrl();

// Helper to get the server URL without the /api suffix
export const getServerBaseUrl = () => {
  return getApiUrl().replace("/api", "");
};

// App configuration
export const APP_NAME = process.env.REACT_APP_NAME || "Learn Hub";
export const MAX_UPLOAD_SIZE =
  Number(process.env.REACT_APP_MAX_UPLOAD_SIZE) || 50 * 1024 * 1024; // Default to 50MB

// App configuration object
export const APP_CONFIG = {
  appName: process.env.REACT_APP_NAME || "Learn Hub",
  companyName: process.env.REACT_APP_COMPANY || "AITTHISONE",
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "info@aitthisone.com",
};

// Get the base server URL (without /api)
export const getServerUrl = (): string => {
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  if (serverUrl && serverUrl !== "undefined" && serverUrl !== "null") {
    return serverUrl;
  }

  const apiUrl = getApiUrl();
  if (apiUrl && apiUrl !== "undefined" && apiUrl !== "null") {
    return apiUrl.replace("/api", "");
  }
  return FALLBACK_API_ENDPOINT.replace("/api", "");
};
